/**
 * "Try risk-free" / "Buy now" links on Resilia product pages: smooth-scroll to the buy box
 * (#buy) instead of jumping. Falls back to the product section, then the top of the page.
 * Works with Horizon's scroll container. Loaded as a module, so it runs once however many
 * sections include it.
 */
document.addEventListener('click', (event) => {
  const link = event.target instanceof Element ? event.target.closest('[data-rn-scroll-top]') : null;
  if (!link) return;
  const href = link.getAttribute('href') || '';
  if (href && !href.startsWith('#')) return;
  event.preventDefault();
  const target =
    document.getElementById('buy') ||
    document.querySelector('rn-pdp, rn-pdp-flowvea') ||
    document.getElementById('MainContent');
  target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
});
